import { Component, HostBinding, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { WidgetSettingsControlBase } from '../control-base';
import { DropdownSettingsModelV2 } from '@fi-shared/dropdown';
import { SiteMapService } from '@fi-app/site-map/site-map.service';
import { isDefined } from '@fi-shared/utils/is-defined';
import { LightWeightClass } from '@fi-app/core/light-weight-class';
import { ILightWeightObject } from '@fi-shared/models';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'fi-widget-settings-control-sitemap',
    templateUrl: './sitemap.component.html',
    styleUrls: ['./sitemap.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-widget-settings-control-sitemap' },
    standalone: false,
})
export class WidgetSettingsControlSitemapComponent extends WidgetSettingsControlBase implements OnInit {
    @HostBinding('class.widget-list-settings')
    @HostBinding('class.EditWidgetContentPadding')
    @HostBinding('class.widget-settings-block-padding')
    isWidgetListSettings() {
        return this.widgetMode;
    }
    siteMaps$ = new BehaviorSubject<ILightWeightObject[]>([]);
    disabled$ = new BehaviorSubject<boolean>(false);

    constructor(
        injector: Injector,
        private siteMapService: SiteMapService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.setSettingsData();
    }

    private setSettingsData() {
        this.siteMapService.getLightWeightSiteMaps().then((response: ILightWeightObject[]) => {
            this.siteMaps$.next(response);
            const currentSiteMapId = this.Settings.SiteMapId;
            if (currentSiteMapId && !response.find((siteMap) => siteMap.Id === currentSiteMapId)) {
                // current user has no access to sitemap embed to home page widget, fetch only current sitemap and disable dropdown
                this.siteMapService.getLightWeightSiteMap(currentSiteMapId).then((siteMap: ILightWeightObject) => {
                    if (siteMap) {
                        this.siteMaps$.next([siteMap]);
                        this.disabled$.next(true);
                    }
                });
            }
        });

        if (!isDefined(this.Settings.displayTitle)) this.Settings.displayTitle = true;

        if (!isDefined(this.Settings.displayNumbering)) this.Settings.displayNumbering = true;

        if (!isDefined(this.Settings.displayFiles)) this.Settings.displayFiles = true;
    }
}
